/* 机构详情跳转 */
export const orgMixin = {
  methods: {
    // linkOrg(item) {
    //   this.$router.push({
    //     name: 'org-detail',
    //     params: { id: item.id }
    //   })
    //   // this.$router.push(`/org-detail/${item.id}`)
    // },
    linkOrg ({ item = {}, query = {} }) {
      const id = item.id || item.orgId
      this.$router.push({
        name: 'org-detail',
        params: { id },
        query
      })
    }
  }
}
